import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {
  
  private selectedView: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private itemsBrands: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private itemsFavorite: BehaviorSubject<string> = new BehaviorSubject<string>('');
  
  constructor(private http: HttpClient) { }

  getCountries(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.BASE + '/' + dataIn.catalogueId + '/countriesInUse';

    return this.http.get(url);

  }

  getSectors(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_SECTORS + '?eventName=' + dataIn.eventName;

    return this.http.get(url);

  }

  getOds(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_ODS + '?eventName=' + dataIn.eventName;

    return this.http.get(url);

  }

  getMasterProperties(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_MASTER_PROPERTIES + '?eventName=' + dataIn.eventName;

    return this.http.get(url);

  }

  getHierarchicalProperties(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_HIERARCHICAL_PROPERTIES + '?eventName=' + dataIn.eventName;

    return this.http.get(url);

  }

  getMultiEvents(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.BASE + '/' + dataIn.catalogueId + CONSTANTS.END_POINTS.FILTERS.GET_MULTI_EVENTS;

    return this.http.get(url);

  }
  
  getSelectedView(): Observable<string> {
    return this.selectedView.asObservable();
  }

  setSelectedView(newData: string): void {
    this.selectedView.next(newData);
  }

  getKeyBrands(): Observable<string> {
    return this.itemsBrands.asObservable();
  }
  
  setKeyBrands(newItems: string): void {
    this.itemsBrands.next(newItems);
  }

  getKeyFavorite(): Observable<string> {
    return this.itemsFavorite.asObservable();
  }
  
  setKeyFavorite(newItems: string): void {
    this.itemsFavorite.next(newItems);
  }

  sendExpositorByVisitor(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.FILTERS.GET_EMAIL_VISITOR;

    return this.http.post(url, dataIn);

  }

}
